import Box, { BoxProps } from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepConnector from "@mui/material/StepConnector";
import { StepIconProps } from "@mui/material/StepIcon";
import StepLabel from "@mui/material/StepLabel";
import Stepper, { StepperProps } from "@mui/material/Stepper";
import { styled } from "@mui/material/styles";
import React from "react";

const SFConnector = styled(StepConnector)(({ theme }) => ({
  ".MuiStepConnector-line": {
    borderColor: theme.palette.grey[300],
    borderTopWidth: 2,
    borderTopStyle: "dotted",
  },
  "&.Mui-active .MuiStepConnector-line": {
    borderColor: theme.palette.primary.main,
  },
  "&.Mui-completed .MuiStepConnector-line": {
    borderColor: theme.palette.primary.main,
  },
}));

interface StepIconRootProps {
  ownerState: {
    completed: boolean;
    active: boolean;
  };
}

const StepIconRoot = styled("div")<StepIconRootProps>(
  ({ theme, ownerState }) => ({
    backgroundColor: "#fff",
    borderColor: theme.palette.grey[300],
    borderWidth: 1,
    borderStyle: "solid",
    zIndex: 1,
    color: theme.palette.grey[300],
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 700,
    lineHeight: "18px",
    letterSpacing: 0,
    textAlign: "center",
    width: 24,
    height: 24,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.active && {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: "#fff",
    }),
    ...(ownerState.completed && {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: "#fff",
    }),
  })
);

function StepIcon(props: StepIconProps) {
  const { active = false, completed = false, icon } = props;

  return <StepIconRoot ownerState={{ completed, active }}>{icon}</StepIconRoot>;
}

interface SFStepperProps {
  steps: string[];
  activeStep: number;
  boxProps?: BoxProps;
  stepperProps?: StepperProps;
}

const SFStepper: React.FC<SFStepperProps> = ({
  steps,
  activeStep,
  boxProps,
  stepperProps,
}) => {
  return (
    <Box display="flex" justifyContent="flex-start" {...boxProps}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<SFConnector />}
        {...stepperProps}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel StepIconComponent={StepIcon} />
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default SFStepper;
